/** Marketing-site GA4 property. Do not import the webapp `ga.ts`. */
export const GA_MEASUREMENT_ID = "G-QWXNXSLZZ8";

type GtagFn = (...args: unknown[]) => void;

function getGtag(): GtagFn | null {
  if (typeof window === "undefined") return null;
  const w = window as unknown as { gtag?: GtagFn };
  return typeof w.gtag === "function" ? w.gtag : null;
}

/** One GA4 `page_view` for the current document URL. No-op until the stub runs. */
export function firePageView(): void {
  const gtag = getGtag();
  if (!gtag) return;
  gtag("event", "page_view", {
    page_path: window.location.pathname,
    page_location: window.location.href,
    page_title: document.title,
  });
}
